import React from "react";

const Footer = () => {
    return (
        <>
            <footer>
                <div className="social-links">
                    <a href="https://github.com/meskv"><i className="fab fa-github" /></a>
                    <a href="https://www.linkedin.com/in/me-skv/"><i className="fab fa-linkedin" /></a>
                    {/* <a href="https://www.instagram.com/me_skv/"><i className="fab fa-instagram" /></a> */}
                    <a href="mailto:krsk1495@gmail.com"><i className="fas fa-envelope" /></a>
                </div>
            </footer>
        </>
    )
}

export default Footer;